module.exports = __webpack_public_path__ + "media/images/country_flags/ci-e5138aa265508c53282aab275d8a732d.png";